import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import MainComponent from "./components/MainComponent";

function App() {
  return (
    <div className="mainCont">
      <MainComponent />
    </div>
  );
}

export default App;
